<!-- <template>
  <v-card flat>
    <v-card-text>
      <v-form ref="form">
        <v-text-field
          label="Nome do dependente"
          v-model="dependenteEnviar.nome"
          :rules="[(v) => !!v || 'Informe o nome do dependente']"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
          class="mb-3"
        ></v-text-field>
        <v-text-field
          type="date"
          label="Data de nascimento"
          v-model="dependenteEnviar.dtNascimento"
          :rules="[(v) => !!v || 'Informe a data de nascimento']"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
        ></v-text-field>

        <v-checkbox
          label="Dependente para Salário Família"
          v-model="dependenteEnviar.depSalarioFamilia"
        ></v-checkbox>

        <v-checkbox
          label="Dependente para Imposto de Renda"
          v-model="dependenteEnviar.depImpostoRenda"
        ></v-checkbox>

        <v-card
          flat
          outlined
          style="border-color: red"
          v-if="dependenteSelec && dependenteSelec.cadexistehcm"
          class="mb-4"
        >
          <v-card-text class="pb-0 pt-0">
            <v-checkbox
              label="Inativar Dependente"
              color="red"
              v-model="dependenteEnviar.inativarDepend"
            ></v-checkbox>
          </v-card-text>
        </v-card>

        <v-textarea
          label="Observação"
          rows="3"
          v-model="dependenteEnviar.observacao"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn rounded small color="info" @click="continuar()"
        >Continuar
        <v-icon size="18" class="ml-2">mdi-arrow-right</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";

export default {
  computed: mapState("dependentes", ["dependenteEnviar", "dependenteSelec"]),
  data: () => ({
    idade: 0,
    inativarDepend: false,
  }),
  methods: {
    ...mapMutations("dependentes", ["setNextStep"]),
    continuar() {
      if (this.$refs.form.validate()) {
        if (this.dependenteEnviar.inativarDepend) {
          var numCarac = 10;
          if (this.dependenteEnviar.observacao.trim().length <= numCarac) {
            this.$toasted.error(
              `Para solicitar a inativação do funcionário é necessário informar uma observação de pelo menos ${numCarac} caracteres`,
            );
            return;
          }
        }

        var difDias = 1;
        if (moment(this.dependenteEnviar.dtNascimento).isValid())
          difDias = moment(this.dependenteEnviar.dtNascimento).diff(
            moment().format("YYYY-MM-DD"),
            "days",
          );

        if (difDias > 0) {
          this.$toasted.error("Informe corretamente a data de nascimento");
          return;
        }

        if (
          !this.dependenteEnviar.depSalarioFamilia &&
          !this.dependenteEnviar.depImpostoRenda
        ) {
          this.$toasted.error(
            "Selecione pelo menos um tipo de dependente: Salário Família ou Imposto de Renda",
          );
          return;
        }
        this.setNextStep();
      }
    },
  },
};
</script>

<style></style> -->

<template>
  <v-card flat>
    <v-card-text>
      <v-form ref="form">
        <v-text-field
          label="Nome do dependente"
          v-model="dependenteEnviar.nome"
          :rules="[(v) => !!v || 'Informe o nome do dependente']"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
          class="mb-3"
        ></v-text-field>
        <v-text-field
          type="date"
          label="Data de nascimento"
          v-model="dependenteEnviar.dtNascimento"
          :rules="[(v) => !!v || 'Informe a data de nascimento']"
          :disabled="dependenteSelec && dependenteSelec.cadexistehcm"
        ></v-text-field>

        <v-checkbox
          label="Dependente Imposto de Renda"
          v-model="dependenteEnviar.depImpostoRenda"
        ></v-checkbox>

        <v-card
          flat
          outlined
          style="border-color: red"
          v-if="dependenteSelec && dependenteSelec.cadexistehcm"
          class="mb-4"
        >
          <v-card-text class="pb-0 pt-0">
            <v-checkbox
              label="Inativar Dependente"
              color="red"
              v-model="dependenteEnviar.inativarDepend"
            ></v-checkbox>
          </v-card-text>
        </v-card>

        <v-textarea
          label="Observação"
          rows="3"
          v-model="dependenteEnviar.observacao"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn rounded small color="info" @click="continuar()"
        >Continuar
        <v-icon size="18" class="ml-2">mdi-arrow-right</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";

export default {
  computed: mapState("dependentes", ["dependenteEnviar", "dependenteSelec"]),
  data: () => ({
    idade: 0,
    inativarDepend: false,
  }),
  methods: {
    ...mapMutations("dependentes", ["setNextStep"]),
    continuar() {
      if (this.$refs.form.validate()) {
        if (this.dependenteEnviar.inativarDepend) {
          var numCarac = 10;
          if (this.dependenteEnviar.observacao.trim().length <= numCarac) {
            this.$toasted.error(
              `Para solicitar a inativação do funcionário é necessário informar uma observação de pelo menos ${numCarac} caracteres`,
            );
            return;
          }
        }

        var difDias = 1;
        if (moment(this.dependenteEnviar.dtNascimento).isValid())
          difDias = moment(this.dependenteEnviar.dtNascimento).diff(
            moment().format("YYYY-MM-DD"),
            "days",
          );

        if (difDias > 0) {
          this.$toasted.error("Informe corretamente a data de nascimento");
          return;
        }
        this.setNextStep();
      }
    },
  },
};
</script>

<style></style>
